import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["hasAllSelect", "label", "options", "handleOnChange", "filterKey", "disabledOptions"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Typography, RaiseColors, Divider } from "componentLibrary";
import { CheckBoxGroup } from "componentLibrary/FilterPopper/CheckboxFilterGroup";
import { CheckboxGroupBaseField } from "./CheckboxGroupField";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var WorkplaceCheckboxGroupField = function WorkplaceCheckboxGroupField(_ref) {
  var hasAllSelect = _ref.hasAllSelect,
    label = _ref.label,
    options = _ref.options,
    handleOnChange = _ref.handleOnChange,
    filterKey = _ref.filterKey,
    disabledOptions = _ref.disabledOptions,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CheckboxGroupBaseField, _objectSpread(_objectSpread({
    label: label,
    options: options,
    handleOnChange: handleOnChange,
    hasAllSelect: hasAllSelect
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        marginLeft: "8px"
      },
      children: /*#__PURE__*/_jsx(CheckBoxGroup, {
        filterName: label,
        checkboxGroupElements: options,
        onChange: function onChange(event) {
          return handleOnChange(event, filterKey);
        }
      })
    }), (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.length) > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Divider, {
        color: RaiseColors.neutral500,
        style: {
          margin: "13px 0px"
        }
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_small",
        color: RaiseColors.midnightPurple,
        weight: "semibold",
        children: "No Data Available"
      }), /*#__PURE__*/_jsx("div", {
        style: {
          marginLeft: "8px"
        },
        children: /*#__PURE__*/_jsx(CheckBoxGroup, {
          filterName: label,
          checkboxGroupElements: disabledOptions,
          onChange: function onChange(event) {
            return handleOnChange(event, filterKey);
          }
        })
      })]
    }) : null]
  }));
};
export default WorkplaceCheckboxGroupField;